import queryView from '../../views/driver-manage/driver-query.vue';
import importView from '../../views/driver-manage/driver-import.vue';
var driverManage = [
    {
        name: 'driverQuery',
        path: 'query',
        component: queryView,
    },
    {
        name: 'driverImport',
        path: 'import',
        component: importView,
    },
];
export default driverManage;
